import type { CallScoreResult } from './calculateCallScore';
import { sendAnalyticsInfo } from './sendAnalytics';

import type { ConnectionMetrics } from 'features/analytics/interfaces/';
import type { WebRTCCallQualityAnalytics } from 'features/analytics/services/';

type ConnectionResolution = Pick<
  ConnectionMetrics,
  'inboundVideoResolution' | 'outboundVideoResolution'
>;

export const sendWebRTCCallScore = (
  peerId: string,
  score: CallScoreResult,
  dispatch: (action: any) => void,
  callId?: number,
  connectionResolution?: ConnectionResolution,
  voyagerForkingUsed?: boolean
): void => {
  dispatch(
    sendAnalyticsInfo({
      Event: 'CallScore',
      Message: `Call quality score for peer ${peerId}`,
      Method: 'sendWebRTCCallScore',
      CallId: callId,
      CallScore: {
        peerId,
        timestamp: new Date().toISOString(),
        score: score.score,
        grade: score.grade,
        voyagerForkingUsed: voyagerForkingUsed ?? false,
        metrics: score.metrics,
        resolution: connectionResolution,
        breakdown: score.breakdown,
      },
    })
  );
};

export const sendWebRTCMetrics = (
  globalAnalyticsInstance: WebRTCCallQualityAnalytics,
  dispatch: (action: any) => void
): void => {
  if (!globalAnalyticsInstance) {
    return;
  }

  // Only send metrics for active connections to avoid unnecessary data
  const activeConnections = globalAnalyticsInstance.getActiveConnections();
  activeConnections.forEach((peerId) => {
    const metrics = globalAnalyticsInstance?.getLatestConnectionMetrics(peerId);
    if (metrics) {
      dispatch(
        sendAnalyticsInfo({
          Event: 'WebRTCMetrics',
          Message: `Periodic WebRTC metrics for peer ${peerId}`,
          Method: 'WebRTCAnalytics',
          PeerId: peerId,
          Metrics: metrics,
          Timestamp: new Date().toISOString(),
        })
      );
    }
  });
};
